function* OrganizationIterator(organizations, batchSize = 1, predicate = null) {
    if (!Array.isArray(organizations)) yield [];

    // Applying the predicate to filter organizations if any
    const filteredOrganizations = predicate ? organizations.filter(predicate) : organizations;
    if (filteredOrganizations.length === 0) yield [];

    const batchArrays = batchArray(filteredOrganizations, batchSize);

    
    for(let i = 0; i < batchArrays.length; i++) {
        yield batchArrays[i];
    }
}



function batchArray(array, batchSize) {
    const batchedArray = [];
    for (let i = 0; i < array.length; i += batchSize) {
        batchedArray.push(array.slice(i, i + batchSize));
    }
    return batchedArray;
}

export default OrganizationIterator;
